import { __extends } from "tslib";
import * as React from 'react';
import * as color from 'color';
export var colorPickerLineBoardKey = 'color-picker-line-board';
var ColorPickerLineBoard = /** @class */ (function (_super) {
    __extends(ColorPickerLineBoard, _super);
    function ColorPickerLineBoard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.slider = null;
        _this.clamp = function (num, min, max) {
            return (num <= min ? min : num >= max ? max : num);
        };
        _this.onMarkerDragStart = function (e) {
            e.preventDefault();
            window.addEventListener('mousemove', _this.onMarkerDrag);
            window.addEventListener('touchmove', _this.onMarkerDrag);
            window.addEventListener('mouseup', _this.onMarkerDragEnd);
            window.addEventListener('touchcancel', _this.onMarkerDragEnd);
            window.addEventListener('touchend', _this.onMarkerDragEnd);
            if (_this.slider) {
                _this.sliderRect = _this.slider.getBoundingClientRect();
                _this.setNewColorByMouseEvent(e);
            }
        };
        _this.onMarkerDrag = function (e) {
            _this.setNewColorByMouseEvent(e);
        };
        _this.onMarkerDragEnd = function () {
            window.removeEventListener('touchmove', _this.onMarkerDrag);
            window.removeEventListener('mousemove', _this.onMarkerDrag);
            window.removeEventListener('touchcancel', _this.onMarkerDragEnd);
            window.removeEventListener('touchend', _this.onMarkerDragEnd);
            window.removeEventListener('mouseup', _this.onMarkerDragEnd);
        };
        _this.getHueByMouseEvent = function (e) {
            var eventX = 0;
            eventX = e.clientX ? e.clientX : e.touches[0].clientX;
            if (_this.sliderRect) {
                var x = eventX - _this.sliderRect.left;
                return _this.clamp((360 * x) / _this.sliderRect.width, 0, 359);
            }
            return 0;
        };
        _this.setNewColorByMouseEvent = function (e) {
            var _a = _this.props, onChange = _a.onChange, current = _a.current;
            var h = _this.getHueByMouseEvent(e);
            onChange('', color({ h: h, s: current.saturationv(), v: current.value() }));
        };
        _this.setRef = function (e) {
            _this.slider = e;
        };
        return _this;
    }
    ColorPickerLineBoard.prototype.componentWillUnmount = function () {
        this.onMarkerDragEnd();
    };
    ColorPickerLineBoard.prototype.render = function () {
        // HUE is an integer value from 0 to 360.
        var percentage = (this.props.current.hue() / 360) * 100;
        return (React.createElement("div", { className: 'color-picker-line-board', ref: this.setRef, onMouseDown: this.onMarkerDragStart, onTouchStart: this.onMarkerDragStart },
            React.createElement("div", { className: 'handle', style: { left: percentage + "%" } })));
    };
    return ColorPickerLineBoard;
}(React.PureComponent));
export { ColorPickerLineBoard };
//# sourceMappingURL=index.js.map